import { css } from '@emotion/react'
import styled from '@emotion/styled'

const sortersStyles = ({ theme }) => css`
  label: sorters;

  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  column-gap: ${theme.spacings.mega};

`

export const Sorters = styled('div')(sortersStyles)
